<template>

  <div
    class="banner"
    :style="{
      backgroundColor: config.backgroundColor,
      color: 'var(--tokens-text)',
    }"
  >
    <KIcon
      :icon="config.icon"
      class="icon"
      :color="config.iconColor"
    />
    <div class="content">
      <slot></slot>
    </div>
  </div>

</template>


<script>

  export default {
    name: 'DocsBanner',
    props: {
      a11y: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      config() {
        if (this.a11y) {
          return {
            icon: 'a11y',
            backgroundColor: 'var(--palette-orange-v50)',
            iconColor: undefined,
          };
        }
        return {
          icon: 'info',
          backgroundColor: 'var(--palette-lightblue-v50)',
          iconColor: 'var(--palette-lightblue-v500)',
        };
      },
    },
  };

</script>


<style lang="scss" scoped>

  .banner {
    display: flex;
    gap: 12px;
    padding: 12px 16px;
    margin: 16px 0;
    border-radius: 4px;
  }

  .icon {
    position: relative;
    top: 0;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }

  .content {
    flex: 1;
    font-size: 1em;
  }

  // long paths and identifiers have no break opportunity of their own and
  // overflow the banner on a narrow screen
  .content ::v-deep code {
    overflow-wrap: anywhere;
  }

</style>
